var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "queries-drawer elevation-1 card-border-right card-bg-3 mr-0",
      class: { "mr-2": _vm.drawer },
      style: _vm.drawer ? "flex-basis: 300px;" : "flex-basis: 0px;",
    },
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c("v-subheader", { staticClass: "subheading primary--text" }, [
            _vm._v("\n      Saved Queries\n    "),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "", depressed: "" },
              on: {
                click: function ($event) {
                  return _vm.closeDrawer()
                },
              },
            },
            [_c("v-icon", [_vm._v("\n        close\n      ")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-item-group",
        {
          attrs: { mandatory: "", "active-class": "white--text" },
          model: {
            value: _vm.filterToggle,
            callback: function ($$v) {
              _vm.filterToggle = $$v
            },
            expression: "filterToggle",
          },
        },
        [
          _c(
            "v-subheader",
            { staticStyle: { display: "inline", cursor: "default" } },
            [_vm._v("Show:")]
          ),
          _vm._v(" "),
          _c("v-item", {
            attrs: { value: _vm.filterToggles.all },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ active, toggle }) {
                  return _c(
                    "v-chip",
                    {
                      staticClass: "chipFilter",
                      attrs: {
                        small: "",
                        color: active ? "primary" : "default",
                        selected: active,
                      },
                      on: { click: toggle },
                    },
                    [_vm._v("\n        All\n      ")]
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("v-item", {
            attrs: { value: _vm.filterToggles.shared },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ active, toggle }) {
                  return _c(
                    "v-chip",
                    {
                      staticClass: "chipFilter",
                      attrs: {
                        small: "",
                        color: active ? "primary" : "default",
                        selected: active,
                      },
                      on: { click: toggle },
                    },
                    [_vm._v("\n        Shared\n      ")]
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("v-item", {
            attrs: { value: _vm.filterToggles.self },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ active, toggle }) {
                  return _c(
                    "v-chip",
                    {
                      staticClass: "chipFilter",
                      attrs: {
                        small: "",
                        color: active ? "primary" : "default",
                        selected: active,
                      },
                      on: { click: toggle },
                    },
                    [_vm._v("My queries\n      ")]
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-list",
        {
          staticClass: "py-0",
          style: { "min-height": _vm.pagination.size * 77 + "px" },
          attrs: { "three-line": "", dense: "" },
        },
        [
          _vm.loading.queries
            ? _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-progress-circular", {
                        staticClass: "mx-auto",
                        attrs: { color: "info", indeterminate: "" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : [
                _vm._l(_vm.queries, function (query, index) {
                  return [
                    _c(
                      "v-list-tile",
                      {
                        key: `query-${index}`,
                        staticClass: "queries-list",
                        class: {
                          "active-query-item": _vm.isSelectedQuery(query),
                        },
                        attrs: { disabled: _vm.loading.queryDetails },
                        on: {
                          click: function ($event) {
                            return _vm.loadQuery(query)
                          },
                        },
                      },
                      [
                        _c(
                          "v-list-tile-content",
                          { staticClass: "pl-2" },
                          [
                            _c(
                              "v-list-tile-title",
                              {
                                class: {
                                  "info--text": _vm.isSelectedQuery(query),
                                },
                                staticStyle: {
                                  overflow: "unset",
                                  display: "flex",
                                },
                              },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "", "open-delay": 600 },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "div",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "font-weight-medium",
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(query.name) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(query.name) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-spacer"),
                                _vm._v(" "),
                                query.isShared
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "", "open-delay": 600 },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        staticClass: "pa-1",
                                                        attrs: { small: "" },
                                                      },
                                                      on
                                                    ),
                                                    [_vm._v("share")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                  Query is shared\n                "
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-sub-title",
                              {
                                staticStyle: {
                                  overflow: "hidden",
                                  height: "100%",
                                },
                              },
                              [
                                _c("div", [
                                  [
                                    _vm.filterToggles.shared,
                                    _vm.filterToggles.all,
                                  ].includes(_vm.filterToggle)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "caption",
                                          class: {
                                            "blurry-text":
                                              !_vm.usersDetail[query.userId],
                                            "teal--text":
                                              query.userId == _vm.userId,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.usersDetail[query.userId]
                                                  ? _vm.usersDetail[
                                                      query.userId
                                                    ].Username
                                                  : query.userId
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "open-delay": 600,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "font-weight-medium",
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                query.lastUpdated,
                                                                _vm.dateFormats
                                                                  .prettyDateFormat
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDate(
                                                  query.lastUpdated,
                                                  _vm.dateFormats
                                                    .prettyDateTimeFormat
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                  —\n                  "
                                      ),
                                      query.description
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                right: "",
                                                "open-delay": 600,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                query.description
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(query.description)
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v("no description"),
                                          ]),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-divider", { attrs: { vertical: "" } }),
                        _vm._v(" "),
                        _c(
                          "v-list-tile-content",
                          {
                            staticStyle: { flex: "0 0 35px" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            query.loading
                              ? _c("v-progress-circular", {
                                  staticClass: "mx-auto",
                                  attrs: { color: "info", indeterminate: "" },
                                })
                              : _c(
                                  "v-menu",
                                  {
                                    attrs: { "offset-y": "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    staticStyle: {
                                                      height: "100%",
                                                      "min-width": "0",
                                                    },
                                                    attrs: {
                                                      ripple: {
                                                        style:
                                                          "height: 100%; width: 100%;",
                                                      },
                                                      tile: "",
                                                      block: "",
                                                      flat: "",
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color:
                                                          _vm.isSelectedQuery(
                                                            query
                                                          )
                                                            ? "info"
                                                            : "",
                                                      },
                                                    },
                                                    [_vm._v("more_vert")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "v-list",
                                      { staticClass: "py-0" },
                                      [
                                        _c(
                                          "v-list-tile",
                                          {
                                            attrs: {
                                              disabled: !_vm.canRemove(query),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.confirmRemoveQuery(
                                                  query
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-tile-avatar",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color: _vm.canRemove(
                                                        query
                                                      )
                                                        ? "error"
                                                        : "",
                                                    },
                                                  },
                                                  [_vm._v("delete_forever")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-list-tile-title", [
                                              _vm._v("Remove"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-divider", { key: `divider-${index}` }),
                  ]
                }),
                _vm._v(" "),
                _vm.queries && _vm.queries.length === 0
                  ? _c(
                      "v-list-tile",
                      { staticClass: "py-3 text-xs-center" },
                      [
                        _c(
                          "v-list-tile-content",
                          { staticStyle: { "align-items": "center" } },
                          [
                            _vm.filterToggle == _vm.filterToggles.shared
                              ? [
                                  _c("v-icon", [_vm._v("share")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n              There are no shared queries yet.\n            "
                                    ),
                                  ]),
                                ]
                              : [
                                  _c("v-icon", [_vm._v("save")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n              Save a query and it will show up here!\n            "
                                    ),
                                  ]),
                                ],
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("Pagination", {
        model: {
          value: _vm.pagination,
          callback: function ($$v) {
            _vm.pagination = $$v
          },
          expression: "pagination",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }